import { createContext, useState, useEffect } from 'react';
import Router from "./Router.js";

import { supabase } from '../supabaseClient.js';
import { JamPadProfile } from '../DataModels.ts';

// allows children components of a page to update parent data
// e.g. when the RSVP button is clicked, update the same map w/ RSVP count and status
  // this update propogates through all componenets back down to child
export const EventMapContext = createContext({ 
  events: new Map(), 
  setEvents: (_newEvents) => {}
});

// same idea, caching logged in profile
// object shared by ALL routes.
export const CurrProfileContext = createContext({
  profile: {} as JamPadProfile | null,
  setProfile: (_newProfile) => {},
  updateProfile: () => {}
});

const App = () => {
  const [profile, setProfile] = useState<JamPadProfile | null>(null);
  const [initialized, setInit] = useState(false);

  // check current user, cache profile data if possible
  async function getCurrUser() {
    const { data } = await supabase.auth.getSession();
    if(data.session?.user) {
      const {data: profileData, error } = await supabase
          .rpc("load_profile", { profile_id: data.session.user.id, user_id: data.session.user.id})
          .select().single<JamPadProfile>();
      if(error) {
          console.error("Failed to load current user: " + error.message);
      } else if(profileData && !profile) {
          setProfile(profileData);
      }
    } else {
      setProfile(null);
    }
    setInit(true);
  }

  useEffect(() => {
    if(!initialized) {
      getCurrUser();
    }
  }, []);

  return (
    <CurrProfileContext.Provider value={{ 
      profile, 
      setProfile: (p) => setProfile(p),
      updateProfile: () => getCurrUser(),
    }}>
      <Router/>
    </CurrProfileContext.Provider>
  );
}
export default App;